import { FiAlertCircle, FiInfo } from 'react-icons/fi'

import { t } from 'i18next'
import moment from 'moment'

import Tooltip from '~/components/Tooltip'

export type MetricAlertProps = Readonly<{
  value: number | string | null | undefined
  settledDay?: string | null
  loading?: boolean
}>

export const formatSettledDay = (settledDay?: string | null) => {
  const date = moment((settledDay || '').slice(0, 10), 'YYYY-MM-DD', true)

  return date.isValid()
    ? date.format(t('common:patterns.dateMonth'))
    : undefined
}

type MetricAlertIconProps = Readonly<{
  text: string
  ariaLabel: string
  variant: 'warning' | 'informational'
  testId?: string
}>

export function MetricAlertIcon({
  text,
  ariaLabel,
  variant,
  testId
}: MetricAlertIconProps) {
  const Icon = variant === 'warning' ? FiAlertCircle : FiInfo
  const color = variant === 'warning' ? '#d99a2b' : '#4d70b3'

  return (
    <Tooltip
      ariaLabel={ariaLabel}
      noMargin
      onTriggerClick={event => event.stopPropagation()}
      onTriggerKeyDown={event => event.stopPropagation()}
      text={text}
    >
      <span
        data-testid={testId}
        data-variant={variant}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          color,
          height: '100%'
        }}
      >
        <Icon aria-hidden="true" size={13} />
      </span>
    </Tooltip>
  )
}
